<template>

    <!-- 问题完成率统计 -->
    <el-table :data="problemCompletionRateTableData" :height="height">
        <el-table-column
                prop="dcnumName"
                label="数据中心">
        </el-table-column>
        <el-table-column
                prop="problemCompletionRate"
                label="问题完成率">
        </el-table-column>
        <el-table-column
                prop="opProblemCompletionRate"
                label="运维问题完成率">
        </el-table-column>
        <el-table-column
                prop="seniorProblemCompletionRate"
                label="高维问题完成率">
        </el-table-column>
    </el-table>

</template>

<script>
    import {formatDate} from "element-ui/src/utils/date-util";
    import WorkOrderServer from "@/api/workorder";
    import TicketServer from "@/api/ticket";

    let that;

    export default {
        name: "problemCompletionRate",

        props: {
            height: {
                type: String
            },
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        data() {
            return {
                problemCompletionRateTableData: [],
            }
        },

        methods: {
            query() {
                //问题整改工单
                let wtzgPromise = WorkOrderServer.workOrder.queryWtzg({
                    'roomIds': this.dcnumids,
                    'month': this.searchDate,
                });
                let params1 = {
                    'dcnums': this.dcnumids,
                    'actualstart': this.searchDate,
                    'actualfinish': this.searchDate,
                    'type': 'op',
                }
                //普通运维问题统计
                let opProblemPromise = TicketServer.problem.queryProblemCompletionRate(params1);
                let params2 = {
                    'dcnums': this.dcnumids,
                    'actualstart': this.searchDate,
                    'actualfinish': this.searchDate,
                    'type': 'senior',
                }
                //高维运维问题统计
                let seniorProblemPromise = TicketServer.problem.queryProblemCompletionRate(params2);

                Promise.all([wtzgPromise, opProblemPromise, seniorProblemPromise]).then(res => {
                    that.problemCompletionRateTableData = [];
                    let [wtzg, opProblem, seniorProblem] = res;
                    for (let i = 0; i < this.dcnumids.length; i++) {
                        let lineData = {};
                        lineData.dcnumName = that.dcnumMap.get(that.dcnumids[i] + '');
                        lineData.problemCompletionRate = that.countProblemCompletionRate(wtzg, opProblem, seniorProblem, that.dcnumids[i]);
                        lineData.opProblemCompletionRate = that.countOpProblemCompletionRate(wtzg, opProblem, that.dcnumids[i]);
                        lineData.seniorProblemCompletionRate = that.countSeniorProblemCompletionRate(seniorProblem, that.dcnumids[i]);

                        lineData.problemCompletionRate = lineData.problemCompletionRate == '' ? '-' : (lineData.problemCompletionRate * 100).toFixed(2) + "%";
                        lineData.opProblemCompletionRate = lineData.opProblemCompletionRate == '' ? '-' : (lineData.opProblemCompletionRate * 100).toFixed(2) + "%";
                        lineData.seniorProblemCompletionRate = lineData.seniorProblemCompletionRate == '' ? '-' : (lineData.seniorProblemCompletionRate * 100).toFixed(2) + "%";
                        that.problemCompletionRateTableData.push(lineData);
                    }
                })
            },

            /**
             * 运维问题完成率计算（由问题整改+普通运维问题工单+高维问题工单汇总）
             * @param wtzg
             * @param opProblem
             * @param seniorProblem
             * @param roomid
             */
            countProblemCompletionRate(wtzg, opProblem, seniorProblem, roomid) {
                let wtzgScoreArr = wtzg[roomid];
                let opProblemScoreArr = opProblem[roomid];
                let seniorProblemScoreArr = seniorProblem[roomid];
                let problemScore = [];
                if (opProblemScoreArr == null && seniorProblemScoreArr != null) {
                    problemScore = seniorProblemScoreArr;
                } else if (opProblemScoreArr != null && seniorProblemScoreArr == null) {
                    problemScore = opProblemScoreArr;
                } else if (opProblemScoreArr != null && seniorProblemScoreArr != null) {
                    problemScore[0] = (parseInt(opProblemScoreArr[0]) + parseInt(seniorProblemScoreArr[0])) + "";
                    problemScore[1] = (parseInt(opProblemScoreArr[1]) + parseInt(seniorProblemScoreArr[1])) + "";
                } else if (opProblemScoreArr == null && seniorProblemScoreArr == null) {
                    problemScore = null;
                }
                let score = this.countProblemCompletionRateOper(wtzgScoreArr, problemScore);
                score = isNaN(score) == true ? "" : score;
                return score;
            },

            /**
             * 普通运维问题完成率计算（由问题整改+普通运维问题工单汇总）
             * @param wtzg
             * @param opProblem
             * @param roomid
             */
            countOpProblemCompletionRate(wtzg, opProblem, roomid) {
                var wtzgScoreArr = wtzg[roomid];
                var opProblemScoreArr = opProblem[roomid];
                var score = this.countProblemCompletionRateOper(wtzgScoreArr, opProblemScoreArr);
                score = isNaN(score) == true ? "" : score;
                return score;
            },

            /**
             * 高维问题完成率
             * @param seniorProblem
             * @param roomid
             */
            countSeniorProblemCompletionRate(seniorProblem, roomid) {
                var seniorScore = seniorProblem[roomid];
                var score = 0;
                if (seniorScore == null) {
                    score = "";
                } else {
                    score = parseInt(seniorScore[1]) / parseInt(seniorScore[0]);
                }
                score = isNaN(score) == true ? "" : score;
                return score;
            },

            countProblemCompletionRateOper(scoreArr1, scoreArr2) {
                let score = 0;
                if (scoreArr1 == null && scoreArr2 != null) {
                    score = parseInt(scoreArr2[1]) / parseInt(scoreArr2[0]);
                } else if (scoreArr1 != null && scoreArr2 == null) {
                    score = parseInt(scoreArr1[1]) / parseInt(scoreArr1[0]);
                } else if (scoreArr1 != null && scoreArr2 != null) {
                    score = (parseInt(scoreArr1[1]) + parseInt(scoreArr2[1])) / (parseInt(scoreArr1[0]) + parseInt(scoreArr2[0]));
                } else if (scoreArr1 == null && scoreArr2 == null) {
                    score = "";
                }
                return isNaN(score) == true ? "" : score;
            }

        },

        created() {
            that = this;
        },

        watch: {
            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.length > 0) {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },
        },

    }
</script>

<style scoped>

</style>